export default "__VITE_ASSET__DgTagzdA__"